import { useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import {WebSocketUrl} from '../Utils/Url';

const WebSocketComponent = () => {
  const [connectionStatus, setConnectionStatus] = useState("Disconnected");
  const [accessToken, setAccessToken] = useState(localStorage.getItem("access_token") || null);

  useEffect(() => {
    const handleStorageChange = () => {
      setAccessToken(localStorage.getItem("access_token") || null);
    };
    window.addEventListener('access-token-updated', handleStorageChange);
    return () => {
      window.removeEventListener('access-token-updated', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    console.log(connectionStatus);
  }, [connectionStatus]);

  useEffect(() => {
    if(accessToken) {
      const socket = io(WebSocketUrl, {
        extraHeaders:{ 'Authorization': `Bearer ${accessToken}` }
      });

      setConnectionStatus("Connecting...");

      socket.on("connect", () => {
        setConnectionStatus("Connected");
      });

      socket.on("notification", (data) => {
        const old_push_notification = JSON.parse(localStorage.getItem("pushnotifications")) || [];
        const current_notification = {id: btoa(data.content + data.user_id + data.notify_id), data: data, show: true};
        if(!old_push_notification.some(notification => JSON.stringify(notification) === JSON.stringify(current_notification))) {
          old_push_notification.push(current_notification);
        }
        localStorage.setItem('pushnotifications', JSON.stringify(old_push_notification));
        window.dispatchEvent(new Event('notification-updated'));
      });

      socket.on("notifications", (data) => {
        localStorage.setItem('notifications', JSON.stringify(data));
        window.dispatchEvent(new Event('notification-updated'));
      });

      socket.on("disconnect", (reason) => {
        setConnectionStatus("Disconnected");
      });

      socket.on("connect_error", (error) => {
        setConnectionStatus("Error");
      });

      return () => {
        socket.close();
      };
    }
  }, [accessToken]);
};

export default WebSocketComponent;
